import moment from 'moment';

import { sectionHeader } from './index';

export const tasks = (bidTasks) => {
  const result = [];
  const factory = new Factory();

  if (bidTasks.length > 0) {
    result.push(sectionHeader("Job Tasks"));
  }

  bidTasks.forEach(task => result.push(factory.getTask(task)));

  return result;
};

function Factory() {
    this.getTask = (task) => {
      switch (task.type) {
        case "estimate":
          return getEstimateTask(task);
        case "maintenance":
          return getMaintenanceTask(task);
        case "simple":
          return getSimpleTask(task);
        case "quote":
          return getQuoteTask(task);
        default:
      }
    }
}

const getEstimateTask = (task) => ({
  style: "task",
  stack: [
      {
          columns: [
              {
                  width: 24,
                  image: 'avatarT',

              },
              {
                  width: "*",
                  stack: [
                      { text: "Task", style: "label" },
                      { text: task.title },
                      { text: "", margin: [0, 0, 0, 10] },
                  ]
              },
              {
                  width: 100,
                  text: task.optional ? "Optional" : "Required"
              }
          ]
      },
      {
          columns: [
              {
                width: 24,
                text: ""
              },
              {
                  width: '*',
                  stack: [
                      { text: "Description", style: "label" },
                      { text: task.description },
                  ]
              },
              {
                  width: 100,
                  stack: [
                      { text: "Estimate Amount", style: "label" },
                      { text: `$${Number(task.estimate).toFixed(2)}` },
                  ]
              },
          ],
      },
  ]
});

const getMaintenanceTask = (task) => {
  const startDate = moment(task.scheduleStart);
  const endDate = moment(task.scheduleStart);
  endDate.add(Number(task.scheduleOccurences), 'M');

  const terms = `Terms: ${task.scheduleHours} hours per month starting ${startDate.format("MMMM Do YYYY")} and ending ${endDate.format("MMMM Do YYYY")}`

  return ({
    style: "task",
    columns: [
        {
            width: 24,
            image: 'avatarT',
        },
        {
            width: "*",
                        stack: [
        {
            width: "*",
            stack: [
                        { text: "Task", style: "label" },
                        { text: task.title },
                        { text: "", margin: [0, 0, 0, 10] },
                    ]
                },
                {
                    columns: [

                        {
                            width: '*',
                            stack: [
                                { text: "Description", style: "label" },
                                { text: task.description },
                            ]
                        },
                        {
                            width: 100,
                            stack: [
                                { text: "Monthly Amount", style: "label" },
                                { text: `$${task.monthlyAmount}` },
                            ]
                        },
                    ],
                },
                { text: "", margin: [0, 0, 0, 10] },
                { text: terms },
                { text: "", margin: [0, 0, 0, 10] }
            ]
        }
    ]
  });
};

const getSimpleTask = (task) => ({
  style: "task",
  columns: [
    {
        width: 24,
        image: 'avatarT',
    },
    {
        width: '*',
        stack: [
            { text: "Task", style: "label" },
            { text: task.title },
        ]
    },
    {
        width: 100,
        stack: [
            { text: "Estimate Amount", style: "label" },
            { text: `$${Number(task.estimate).toFixed(2)}` },
        ]
    }
  ]
});

const getQuoteTask = (task) => {
  const quoteTask = {
    style: "task",
    stack: [],
  };

  quoteTask.stack.push(getQuoteTaskHeader(task));

  if (task.labor.length) {
    quoteTask.stack.push(sectionHeader("Labor", true));
    quoteTask.stack.push(getQuoteTable(task.labor));
  }

  if (task.materials.length) {
    quoteTask.stack.push(sectionHeader("Materials", true));
    quoteTask.stack.push(getQuoteTable(task.materials));
  }

  return quoteTask;
};

const getQuoteTaskHeader = (task) => ([
  {
      columns: [
          {
              width: 24,
              image: 'avatarT',
          },
          {
              width: "*",
              stack: [
                  { text: "Task", style: "label"  },
                  { text: task.title },
                  { text: "", margin: [0, 0, 0, 10] }
              ]
          },
          {
              width: 100,
              text: task.optional ? "Optional" : "Required"
          }
      ]
  },
  {
      columns: [
          {
              width: 24,
              text: ""
          },
          {
              width: '*',
              stack: [
                  { text: "Description", style: "label" },
                  { text: task.description },
              ]
          },
          {
              width: 120,
              stack: [
                  {
                      columns: [
                          { text: "Labor", style: "label", width: 50 },
                          { text: `$${task.laborTotal.toFixed(2)}`, width: "*", alignment: "right" },
                      ]
                  },
                  {
                      columns: [
                          { text: "Materials", style: "label", width: 50 },
                          { text: `$${task.materialsTotal.toFixed(2)}`, width: "*", alignment: "right"},
                      ]
                  },
                  {
                      columns: [
                          { text: "Subtotal", style: "label", width: 50 },
                          { text: `$${task.subtotal.toFixed(2)}`, width: "*", alignment: "right" },
                      ]
                  },
              ]
          },
      ],
  },
]);

const getQuoteTable = (items) => {
  const result = {
    layout: "noBorders",
    table: {
        headerRows: 1,
        widths: [36, "*", 60, 60, 60],
        body: []
    }
  };

  result.table.body.push([
    { text: "" },
    { text: "Description", style: "label" },
    { text: "Quantity", style: "label", alignment: "right" },
    { text: "Unit Price", style: "label", alignment: "right" },
    { text: "Total", style: "label", alignment: "right" },
  ]);

  items.forEach(item => {
    const qty = Number(item.quantity);
    const rate = Number(item.rate);
    const total = qty*rate;

    result.table.body.push([
      { text: "" },
      { text: item.description },
      { text: qty, alignment: "right" },
      { text: `$${rate.toFixed(2)}`, alignment: "right" },
      { text: `$${total.toFixed(2)}`, alignment: "right" },
    ]);
  });

  return result;
};



// WEBPACK FOOTER //
// ./src/store/generators/PDF/bid/tasks.js